import React, { ReactNode } from 'react';

import classNames from 'classnames';
import classes from './IconBackgroundWrapper.module.scss';

type IconBackgroundWrapperProps = {
  icon: ReactNode;
  className?: string;
};

const IconBackgroundWrapper = ({ icon, className }: IconBackgroundWrapperProps) => {
  const wrapperClasses = classNames(classes.wrapper, className);
  return <div className={wrapperClasses}>{icon}</div>;
};

export { IconBackgroundWrapper };
